import { useEffect } from "react";

const useBrowserTranslateObserver = (onDetected, onNotDetected) => {
  useEffect(() => {
    const html = document.documentElement;
    const translateCheckElement = document.getElementById('translate-check');

    const checkElement = () => {
      const htmlTranslated = html.className.includes('translated') || (html?.lang && html?.lang !== '');

      const spanTextChanged = translateCheckElement && translateCheckElement.innerText !== translateCheckElement.getAttribute('data-original');

      if (htmlTranslated || spanTextChanged) {
        onDetected();
      } else {
        onNotDetected();
      }
    };

    checkElement();

    const htmlObserver = new MutationObserver(() => {
      checkElement();
    });

    const spanObserver = new MutationObserver(() => {
      checkElement();
    });

    htmlObserver.observe(html, {
      attributes: true,
      attributeFilter: ['lang', 'class'],
    });

    if (translateCheckElement) {
      spanObserver.observe(translateCheckElement, {
        characterData: true,
        subtree: true,
        childList: true
      });
    }

    return () => {
      htmlObserver.disconnect();
      spanObserver.disconnect();
    };
  }, [onDetected, onNotDetected]);
};

export default useBrowserTranslateObserver;
